export const SET_TOC = 'SET_TOC'
export const SET_COMMENTS = 'SET_COMMENTS'
export const SET_SUSTAINABILITY_REPORT = 'SET_SUSTAINABILITY_REPORT'
export const SET_LOADING_COMPLETED = 'SET_LOADING_COMPLETED'
